import React from 'react';
import {
  Card,
  Form,
  Button,
  Input,
  Icon,
  message as showMessage,
  Row,
  Col,
  List,
} from 'antd';
import { getData, patchData } from '../../helper/dataService';
import API from '../../helper/api';

class DeviceCommand extends React.Component {
  state = {
    data: {},
    commands: [],
    assetTypes: [],
    submitted: false,
    fetching: true,
    submittingCommand: false,
  };

  componentDidMount() {
    this.fetchDeviceData();
  }

  fetchDeviceData = () => {
    getData(API.device.command(this.props.match.params.id))
      .then(({ data: { data, status, editable } }) => {
        console.log(data);
        if (status === 'success') {
          this.setState({ commands: data });
        } else if (status === 'failed') {
          showMessage.error('Sorry! Something went wrong');
        }
        this.setState({ fetching: false });
      })
      .catch(() => {
        showMessage.error('Sorry! Something went wrong');
        this.setState({ fetching: false });
      });
  };

  handleSubmitCommand = (e) => {
    e.preventDefault();
    this.props.form.validateFields(['newCommand'], (err, values) => {
      if (!err && values.newCommand) {
        this.setState({ submittingCommand: true });

        patchData(API.device.command(this.props.match.params.id), {
          command: values.newCommand,
        })
          .then(({ data: { status } }) => {
            if (status === 'success') {
              showMessage.success('Command sent successfully');
              this.props.form.resetFields(['newCommand']);
              this.fetchDeviceData();
            } else {
              showMessage.error('Failed to send command');
            }
            this.setState({ submittingCommand: false });
          })
          .catch(() => {
            showMessage.error('Sorry! Something went wrong');
            this.setState({ submittingCommand: false });
          });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const { fetching, commands, submittingCommand } = this.state;

    return (
      <Row type='flex' justify='space-around' align='middle'>
        <Col xs={24} sm={18}>
          <Card
            title={
              <span className='title'>
                <Icon type='cluster' />
                {' Device Command'}
              </span>
            }
          >
            <br />

            {/* Add New Command Section */}
            <Card title='Send New Command' loading={fetching}>
              <Form onSubmit={this.handleSubmitCommand}>
                <Form.Item label='Command' {...formItemLayout}>
                  {getFieldDecorator('newCommand', {
                    rules: [
                      { required: true, message: 'Please enter a command' },
                      { whitespace: true, message: 'Command cannot be empty' },
                    ],
                  })(
                    <Input
                      placeholder='Enter device command'
                      disabled={submittingCommand}
                    />
                  )}
                </Form.Item>
                <Form.Item
                  wrapperCol={{ xs: { span: 24 }, sm: { span: 16, offset: 8 } }}
                >
                  <Button
                    type='primary'
                    htmlType='submit'
                    loading={submittingCommand}
                    icon='send'
                  >
                    Send Command
                  </Button>
                </Form.Item>
              </Form>
            </Card>

            <br />

            {/* Commands List Section */}
            <Card loading={fetching} title='Pending Commands'>
              <List
                dataSource={commands}
                renderItem={(command) => (
                  <List.Item>
                    <span>{command}</span>
                  </List.Item>
                )}
                locale={{ emptyText: 'No commands available' }}
              />
            </Card>
            <br />
          </Card>
        </Col>
      </Row>
    );
  }
}

export default Form.create()(DeviceCommand);
